import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Table, Typography, Space, Button, Popconfirm, Spin, ConfigProvider } from "antd";
import { PageContainer } from "@ant-design/pro-components";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import {
  fetchOOOList,
  deleteOOOThunk,
} from "../../reducer/outOfOrderRoomsReducer";
import AddOrEditOutOfOrderDrawer from "../../components/housekeepingV2/drawers/AddOrEditOutOfOrderDrawer";
import enGB from 'antd/es/locale/en_GB';

const { Text } = Typography;

const OutOfOrderRoomsPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hotelId = useSelector((s) => s.login.hotelDetails?.id);
  const { list, loading, error } = useSelector((s) => s.outOfOrderRooms);
  const rooms = useSelector((s) => s.rooms.data);

  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  useEffect(() => {
    if (hotelId) dispatch(fetchOOOList(hotelId));
  }, [dispatch, hotelId]);

  const openAdd = () => {
    setEditingRecord(null);
    setDrawerVisible(true);
  };

  const openEdit = (record) => {
    setEditingRecord(record);
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setEditingRecord(null);
    setDrawerVisible(false);
  };

  const handleDelete = (record) => dispatch(
  deleteOOOThunk({
    id: record.id,
    roomIds: record.roomIds,
    startDate: record.startDate,
    endDate: record.endDate,
    status: "ROOM_IN_ORDER",
  })
);
;

  const columns = [
    {
      title: "Room Number",
      dataIndex: "roomIds",
      key: "roomNumber",
      render: (ids) =>
        ids
          .map((rid) => {
            const room = rooms.find((r) => r.id === rid);
            return room ? room.name : rid;
          })
          .join(", "),
    },
    {
      title: "Start Date",
      dataIndex: "startDate",
      key: "startDate",
      render: (d) => (d ? moment(d).format("DD MMM YYYY") : "--"),
    },
    {
      title: "End Date",
      dataIndex: "endDate",
      key: "endDate",
      render: (d) => (d ? moment(d).format("DD MMM YYYY") : "--"),
    },
    {
      title: "Out Of Order Marked At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (d) => (d ? moment(d).format("DD MMM YYYY hh:mm A") : "--"),
    },
    {
      title: "Marked By",
      dataIndex: "createdBy",
      key: "createdBy",
      render: (d) => d || "--",
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => openEdit(record)}>
            Edit
          </Button>
          <Popconfirm
            title="Mark selected room(s) as available on these dates?"
            onConfirm={() => handleDelete(record)}
            
          >
            <Button type="link" danger>
              Remove
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
  <ConfigProvider locale={enGB}>

    <div className="pt-16">
      <PageContainer
        header={{
          ghost: false,
          onBack: () => navigate("/dashboard/house-keeping"),
          title: "Out of Order Rooms",
          extra: [
            <Button key="add" type="primary" onClick={openAdd}>
              Add
            </Button>,
          ],
        }}
      >
        {loading ? (
          <div className="text-center py-20">
            <Spin size="large" />
          </div>
        ) : (
          <Table
            rowKey="id"
            columns={columns}
            dataSource={list}
            pagination={false}
            locale={{ emptyText: "No out-of-order entries." }}
          />
        )}

        {error && <Text type="danger">{error}</Text>}

        <AddOrEditOutOfOrderDrawer
          visible={drawerVisible}
          onClose={closeDrawer}
          hotelId={hotelId}
          rooms={rooms}
          mode={editingRecord ? "edit" : "add"}
          record={editingRecord}
        />
      </PageContainer>
    </div>
    </ConfigProvider>
  );
};

export default OutOfOrderRoomsPage;
